<script setup>
import {__, _mareike_nonce, notify} from "../../../assets/javascripts/library";
import TabbedPage from "../../../assets/components/TabbedPage.vue";
import ListCostUnits from "./ListCostUnits.vue";

const props = defineProps({
  data: {
    type: [Array, Object],
    default: () => []
  },
  cost_unit_id: {
    type: Number,
    default: 0
  },

  invoice_id: {
    type: Number,
    default: 0
  }


})

// Prüfen, ob ein ?id= Parameter in der URL übergeben wurde
const urlParams = new URLSearchParams(window.location.search)
const initialCostUnitId = props.cost_unit_id
const initialInvoiceId = props.invoice_id

const tabs = [
  {
    title: __('Current events', 'mareike'),
    component: ListCostUnits,
    endpoint: "/wp-json/mareike/costunits/current-cost-units?mareike_nonce=" + _mareike_nonce(),
    deep_jump_id: initialCostUnitId,
    deep_jump_id_sub: initialInvoiceId,

  },
  {
    title: __('Current running jobs', 'mareike'),
    component: ListCostUnits,
    endpoint: "/wp-json/mareike/costunits/current-running-jobs?mareike_nonce=" + _mareike_nonce(),
    deep_jump_id: initialCostUnitId,
    deep_jump_id_sub: initialInvoiceId,
  },
  {
    title: __('Closed cost units', 'mareike'),
    component: ListCostUnits,
    endpoint: "/wp-json/mareike/costunits/closed-cost-units?mareike_nonce=" + _mareike_nonce(),
    deep_jump_id: initialCostUnitId,
    deep_jump_id_sub: initialInvoiceId,
  },
  {
    title: __('Archived cost units', 'mareike'),
    component: ListCostUnits,
    endpoint: "/wp-json/mareike/costunits/archived-cost-units?mareike_nonce=" + _mareike_nonce(),
    deep_jump_id: initialCostUnitId,
    deep_jump_id_sub: initialInvoiceId,
  },
]
</script>

<template>
  <TabbedPage :tabs="tabs" />
</template>
